export default __webpack_public_path__ + "static/img/vogue_scene_animated_0687.6537cd5.webp";